import React from 'react';

import styles from './RadioCustom.module.scss';

interface IProps {
  id: string;
  labelText: string;
  name?: string;
  checked: boolean;
  disabled?: boolean;
  onChange: () => void;
}

const RadioCustom: React.FC<IProps> = ({ id, labelText, name = 'radio-custom', disabled, checked, onChange }) => {
  return (
    <div className={styles['RadioCustom']}> 
      <input
        id={id}
        type="radio"
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />

      <label htmlFor={id}>
        <span>{labelText}</span>
      </label>
    </div>
  );
}

export default RadioCustom;